import { IDeviceConfig } from "../../../APIRequests/APIPut"
import { DeviceFormConfig } from "../../DevicePage"
import DevicePage from "../../DevicePage"

interface DeviceTabComponentProps {
  deviceConfig: IDeviceConfig
  saveConfig: (config: IDeviceConfig) => void
  configSchema: { [p: string]: any } | undefined
}

export default function Sensors({
  deviceConfig,
  saveConfig,
  configSchema,
}: DeviceTabComponentProps) {
  const formConfig: DeviceFormConfig = {
    Temperature: [
      "temp.enable",
      "temp.lowlim",
      "temp.highlim",
      "temp.prio",
      "temp.schedule.motion",
      "temp.schedule.station",
      "temp.schedule.invent",
    ],

    Humidity: [
      "hum.enable",
      "hum.lowlim",
      "hum.highlim",
      "hum.prio",
      "hum.schedule.motion",
      "hum.schedule.station",
      "hum.schedule.invent",
    ],

    Accelerometer: [
      "accel.threshold",
      "accel.duration",
      "accel.range",
      "accel.prio",
    ],
  }

  return (
    <DevicePage
      deviceConfig={deviceConfig}
      saveConfig={saveConfig}
      configSchema={configSchema}
      formConfig={formConfig}
    />
  )
}
